/**
 * YoMA, speaking to a 12–14 learner.
 *
 * Presentation only — it renders the line it is given. Nothing here reads
 * answers or scores anything. The avatar is decorative company; the words
 * carry the meaning, so the alt text names her and the text is real text
 * (never baked into the image).
 */
import { motion } from "framer-motion";
import yomaAvatar from "@/assets/yoma-avatar.png.asset.json";

export interface YomaSaysProps {
  /** Small label above the line, e.g. "YoMA". */
  eyebrow?: string;
  /** The line itself. Short sentences, second person, warm. */
  children: React.ReactNode;
  className?: string;
}

export function YomaSays({ eyebrow = "YoMA", children, className = "" }: YomaSaysProps) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 8 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.35 }}
      className={`flex items-start gap-3 md:gap-4 ${className}`}
      data-testid="yoma-says"
    >
      <img
        src={yomaAvatar.url}
        alt="YoMA, your mentor assistant"
        data-testid="yoma-avatar"
        className="h-14 w-14 md:h-16 md:w-16 shrink-0 rounded-full object-cover border-2 border-primary/40 bg-secondary"
      />
      <div className="relative rounded-3xl rounded-tl-md border border-primary/30 bg-primary/10 px-4 py-3 md:px-5 md:py-4">
        <p className="text-[10px] font-semibold uppercase tracking-[0.2em] text-primary">
          {eyebrow}
        </p>
        <div className="mt-1 text-sm md:text-base leading-relaxed text-foreground/90">
          {children}
        </div>
      </div>
    </motion.div>
  );
}

export default YomaSays;
